<template>

  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
        <el-form-item label="读书会">
          <el-select v-model="formInline.reading_id" placeholder="请选择读书会" clearable filterable>
            <el-option
              v-for="item in readingList"
              :key="item.reading_id"
              :label="item.name"
              :value="item.reading_id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="姓名/手机号">
          <el-input v-model="formInline.keyword" placeholder="请输入用户名或手机号"></el-input>
        </el-form-item>
        <el-form-item >
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
        </el-form-item>

      </el-form>
    </div>

    <!-- <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">添加读书会</el-button>
    </div> -->

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">

            <el-table-column prop="reading.name" label="读书会名称"></el-table-column>
            <el-table-column prop="user.nickName" label="报名用户"></el-table-column>

            <el-table-column prop="name" label="姓名"></el-table-column>
            <el-table-column prop="phone" label="联系方式"></el-table-column>
            <el-table-column prop="create_time" label="报名时间"></el-table-column>
           <el-table-column prop="is_pay" label="是否支付" width="100">
        <template slot-scope="scope">
          <el-tag 
            :type="scope.row.is_pay == 1 ? 'success' : 'danger'"
            size="small"
            effect="dark"
          >
            {{ scope.row.is_pay == 1 ? '已支付' : '未支付' }}
          </el-tag>
        </template>
      </el-table-column>
            <!-- <el-table-column fixed="right" label="操作" width="90">
              <template slot-scope="scope">
                <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column> -->
          </el-table>
        </div>
      </el-form>
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

    <Add :open_add="open_add" v-if="open_add"   @close="closeAdd"></Add>
    <Edit :open_add="open_edit" :reading_id="reading_id"  v-if="open_edit"   @close="closeEdit"></Edit>

    <el-dialog  style="text-align: center" title="设置标题" :visible.sync="dialogVisible" @close='dialogFormVisible'
    :close-on-click-modal="false"
               :close-on-press-escape="false" :append-to-body="true">
    </el-dialog>

  </div>
</template>

<script>
import AfuncApi from '@/api/afunc.js';
  import Add from './part/add.vue';
  import Edit from './part/edit.vue';

  export default {
    components: {
      Add,
      Edit,
    },
    inject: ['reload'],
    data() {
      return {
        /*是否加载完成*/
        loading: true,
        /*列表数据*/
        tableData: [],
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*搜索表单对象*/
        form: {},
        formInline: {
          reading_id:"",
          keyword:""
        },

        open_add:false,
        open_edit:false,
        reading_id:"",
        dialogVisible:false,
        readingList: [], // 读书会列表
      };
    },
    created() {

      /*获取列表*/
      this.getTableList();
      /*获取读书会列表*/
      this.getReadingList();
    },
    methods: {
      /*获取读书会列表*/
      async getReadingList() {
        let self = this;
        const response = await AfuncApi.call({
          model: 'reading',
          action: 'index',
          page: 1,
          list_rows: 1000
        });
        
        if (response.code === 1 && response.data.list) {
          self.readingList = response.data.list.data || [];
        }
      },

      dialogFormVisible(){
        this.dialogVisible = false;
      },
      setting(e){//读书会标题设置
        // this.categorya_id = e
        this.dialogVisible = true;
      },
       /*关闭添加*/
    closeAdd(e){
      this.open_add=false;
      this.getTableList();
    },
    closeEdit(e){
      this.open_edit=false;
      this.getTableList();
    },
    getData(){
      this.getTableList();
    },
      /*选择第几页*/
      handleCurrentChange(val) {
        this.curPage = val;
        this.getTableList();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getTableList();
      },

      /*获取列表*/
     async getTableList() {
        let self = this;
        self.loading = true;
        const response = await AfuncApi.call({
          model: 'reading_join',
          action: 'index',
          page: this.curPage,
          list_rows: this.pageSize,
          ...this.formInline
        });
        
        if (response.code === 1 && response.data.list) {
           self.loading = false;
          self.tableData = response.data.list.data || [];
          self.totalDataNumber = response.data.list.total || 0;
        }

      },

      /*搜索查询*/
      onSubmit() {
        this.curPage = 1;
        this.getTableList();
      },

      /*添加任务*/
      addClick() {
        this.open_add = true
      },

      /*编辑活动*/
      editClick(row) {
        this.reading_id = row.reading_id;
        this.open_edit = true
      },

      /*删除*/
     async deleteClick(row) {
         await this.$confirm('此操作将删除该读书会及其所有子读书会, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            });
      
            
            const response = await AfuncApi.call({
              model: 'reading',
              action: 'del',
              reading_id: row.reading_id,
            });
            
            if (response.code === 1) {
              this.$message.success('删除成功');
              this.getTableList();
            } else {
              this.$message.error(response.msg || '删除失败');
            }
      }
    }
  };
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/reading/index/registration.vue